// @flow
import React, {Component} from 'react';
import Pagify from 'react-pagify';
import segmentize from 'segmentize';
import classNames from 'classnames';
import './Paginator.css';

export type Props = {
  pagination: Object,
  pages: number,
  onSelect: Function,
};

class Paginator extends Component<Props> {
  props: Props;

  selectPage(page: number) {
    const activePage = Math.min(Math.max(page, 1), this.props.pages);
    if (this.props.pagination.page !== activePage) {
      this.props.onSelect(activePage);
    }
  }

  render() {
    const {pagination: {page}, pages} = this.props;

    return (
      <div className="pagination">
        {pages > 1 &&
          <Pagify.Context
            className="pagify-pagination"
            segments={segmentize({
              page,
              pages,
              beginPages: 1,
              endPages: 1,
              sidePages: 1,
            })}
            onSelect={page => this.selectPage(page)}>
            <Pagify.Button
              page={page - 1}
              className={classNames({disabled: page === 1})}>
              Föregående
            </Pagify.Button>

            <Pagify.Segment field="beginPages" />

            <Pagify.Ellipsis
              className="pagify-ellipsis"
              previousField="beginPages"
              nextField="previousPages"/>

            <Pagify.Segment field="previousPages" />
            <Pagify.Segment
              field="centerPage"
              className="selected" />
            <Pagify.Segment field="nextPages" />

            <Pagify.Ellipsis
              className="pagify-ellipsis"
              previousField="nextPages"
              nextField="endPages"/>

            <Pagify.Segment field="endPages" />

            <Pagify.Button
              page={page + 1}
              className={classNames({disabled: page === pages})}>
              Nästa
            </Pagify.Button>
          </Pagify.Context>
        }
      </div>
    );
  }
}

export default Paginator;



// WEBPACK FOOTER //
// ./src/components/Paginator/Paginator.js